export const story4 = `
{{Oh, sorrowful one.[[x,x,x]]}}
{{You have embraced a bargain you did not understand.[[x,x,x]]}}
{{What do you value most? [[x,x,x]]}}{{Control?[[x,100,x]]}} {{Secrecy?[[x,x,100]]}} {{Eloquence?[[100,x,x]]}}
{{Choose one at the expense of the others, and we may fix this yet.[[100,100,100]]}}
{{Receive the[[100,1,1]]}} {{Quill of the Cordant?[[100,1,1]]<<Quill of the Cordant>>}}
{{Receive the[[1,100,1]]}} {{Scepter of the Warden?[[1,100,1]]<<Scepter of the Warden>>}}
{{Receive the[[1,1,100]]}} {{Mask of Althan[[1,1,100]]<<Mask of Althan>>}}
`;
